import { createSelector } from 'reselect'

function selectBase(state) {
  return state.editor || {}
}

export const selectIsEditorFocused = createSelector(
  selectBase,
  editor => editor.isFocused
)

export const selectIsNoteEditor = state => selectBase(state).mode === 'note'
export const selectIsReplyEditor = state => selectBase(state).mode === 'reply'
